import { getApiClientVigo } from "./ApiClientVigo.js";


/**
 * Generiert eine neue AntragId für einen Antrag.
 * @param {string} kanal - Der Kanal: "meinevigo", "vigoselect" oder "vigokv"
 * @returns {Promise<{success: boolean, antragId?: string, error?: string, status?: number}>}
 */
export async function getAntragId(kanal) {
    try {
        const client = getApiClientVigo();
        const endpoint = '/v2/Tarifrechner/antrag';
        const params = { kanal };
        
        // Debug: Aufruf-URL
        console.log(`[AntragService] GET ${endpoint}?kanal=${kanal}`);
        
        const response = await client.get(endpoint, {
            params,
            validateStatus: function (status) {
                console.log(`[AntragService] Response Status: ${status}`);
                return status < 500; // Resolve only if the status code is less than 500
            }
        });
        
        // Debug: Response JSON
        console.log('[AntragService] Response Data:', JSON.stringify(response.data, null, 2));
        
        // Erfolg prüfen: status === 200 && ok === true && returncode === 0
        if (response.status === 200 && response.data?.ok === true && response.data?.returncode === 0) {
            const antragId = response.data.data;
            console.log(`[AntragService] AntragId erfolgreich generiert: ${antragId}`);
            return {
                success: true,
                antragId: antragId
            };
        } else {
            // API-Fehler (nicht erfolgreich trotz < 500)
            const errorMsg = response.data?.nachricht || 'Unbekannter Fehler beim Generieren der AntragId';
            console.error('[AntragService] API Error:', errorMsg, 'ReturnCode:', response.data?.returncode);
            return {
                success: false,
                error: errorMsg,
                status: response.status
            };
        }
    }
    catch (error) {
        console.error('[AntragService] Exception:', error.message);
        return {
            success: false,
            error: error.message || 'Netzwerkfehler beim Abrufen der AntragId',
            status: 500
        };
    }
}

/**
 * Sendet Antragsdaten an die API.
 * @param {Object} data - Die Antragsdaten
 * @returns {Promise<*>}
 */
export async function postAntrag(data) {
    try {
        const client = getApiClientVigo();
        return await client.post("v1/Antrag4you/", data, {
            validateStatus: function (status) {
                console.log('Service Antrag Status ' + status);
                return status < 500; // Resolve only if the status code is less than 500
            }
        });
    }
    catch (error)
    {
        return {
            'status': 400,
            'data': {
                'returncode': 'Request wurde nicht verarbeitet',
                'fehler' : error.message
            }
        };
    }
}

/**
 * Sendet Policierungsdaten an die API.
 * @param {Object} data - Die Policierungsdaten
 * @returns {Promise<*>}
 */
export async function postPolice(data) {
    try {
        const client = getApiClientVigo();
        return await client.post("v1/Police4you/", data, {
            validateStatus: function (status) {
                console.log('Service Antrag Status ' + status);
                return status < 500; // Resolve only if the status code is less than 500
            }
        });
    }
    catch (error)
    {
        return {
            'status': 400,
            'data': {
                'returncode': 'Request wurde nicht verarbeitet',
                'fehler' : error.message
            }
        };
    }
}

/**
 * Sendet Bestätigungsdaten an die Email-API.
 * @param {Object} data - Die Email-Daten
 * @returns {Promise<*>}
 */
export async function postBestaetigung(data) {
    try {
        const client = getApiClientVigo();
        return await client.post("v1/Email/", data, {
            validateStatus: function (status) {
                console.log('Service Antrag Status ' + status);
                return status < 500; // Resolve only if the status code is less than 500
            }
        });
    }
    catch (error)
    {
        return {
            'status': 400,
            'data': {
                'returncode': 'Request wurde nicht verarbeitet',
                'fehler' : error.message
            }
        };
    }
}





